import { PageSubMenuViewModel } from "./pageSubMenuViewModel.model";

export class PageRootMenuViewModel {
    fSubject: string;
    fId: number;
    fHasSubMenu: boolean;
    PageSubMenuViewModelArray:PageSubMenuViewModel[];

    constructor() {
        this.fSubject = "";
        this.fId = 0;
        this.fHasSubMenu = false;
        this.PageSubMenuViewModelArray=[];
    }
}